import { IDetailsRowCheckStyles } from '@fluentui/react';

export const DetailsRowCheckStyles = (): Partial<IDetailsRowCheckStyles> => ({
  check: [
    {
      opacity: 1,
    },
  ],
});
